import React from 'react';
import { Badge } from '@chakra-ui/react';

const BADGE_CONFIG = {
  LOGIN:    { colorScheme: 'blue',   label: 'Connexion' },
  LOGOUT:   { colorScheme: 'gray',   label: 'Déconnexion' },
  CREATE:   { colorScheme: 'green',  label: 'Créé' },
  SUBMIT:   { colorScheme: 'green',  label: 'Soumis' },
  READ:     { colorScheme: 'cyan',   label: 'Consulté' },
  UPDATE:   { colorScheme: 'orange', label: 'Modifié' },
  APPROVE:  { colorScheme: 'teal',   label: 'Approuvé' },
  COMPLETE: { colorScheme: 'purple', label: 'Terminé' },
  DELETE:   { colorScheme: 'red',    label: 'Supprimé' },
  REJECT:   { colorScheme: 'red',    label: 'Rejeté' },
};

export default function ActionBadge({ actionType }) {
  const cfg = BADGE_CONFIG[actionType] ?? { colorScheme: 'gray', label: actionType };
  return (
    <Badge colorScheme={cfg.colorScheme} borderRadius="md" px={2} py={0.5}>
      {cfg.label}
    </Badge>
  );
}
